
















import {getAllSolutionFilters} from '@/store/state/helpers';
import {FilterTag} from '@/views/amex/app-types';
import Vue from 'vue';
import Button, {ButtonTypes} from '@common/button/button.vue';

export default Vue.extend({
  name: 'PreferencesButton',
  components: {
    Button,
  },
  props: {},
  computed: {
    selectedTags(): FilterTag[] {
      const allTags = getAllSolutionFilters();
      const selectedTags = allTags.filter((tag) => tag.value);

      return selectedTags;
    },

    preferencesNum(): number {
      return this.selectedTags?.length || 0;
    },

    preferencesStr(): string {
      return this.selectedTags?.length ? 'My Preferences' : 'No Preferences';
    },
  },
  data: () => ({
    ButtonTypes,
  }),
  methods: {
    // TODO: open preferences modal here
    // onClick() {
    //   const interestsConfig = {
    //     get availableTags() {
    //       return [...availableCommonInterests.value, ...availableCommonFlightFilters.value];
    //     },
    //     availableCategories: {
    //       [category]: true,
    //       // DINING: ,
    //       // ACCOMMODATION:
    //       // EXPERIENCE
    //     },
    //     onSelectionChange: (tags) => updateCommonStoreTags(availableCommonInterests, tags),
    //   };
    //   this.$modal
    //     .show(InterestsFilterModalVue, interestsConfig)
    //     .then((updatedFilters) => {
    //       updatedFilters && config.onSelectionChange(updatedFilters);
    //     })
    //     .catch(() => {
    //       config.onSelectionChange([]);
    //     });
    // }
  },
});
